import styled from 'styled-components'
import { StyledPaper } from '../../ui-kit/Paper/Paper.styles'

export const FormPaper = styled(StyledPaper)`
  padding: 0;
  overflow: hidden;
`

export const FormHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 5px 1px rgb(231, 229, 230, 0.5);
  border-bottom: 1px solid rgb(210 210 210 / 50%);
  padding: 0 1rem;
  height: 5.063rem;
    font-size:1.8rem;
`

export const FormContent = styled.div`
  padding: 1rem;
`

export const Actions = styled.div`
  display: flex;
  gap: 1rem;
`

export const TabsMobile = styled.div`
    @media (min-width: ${({ theme }) => theme.breakPoints.sm}) {
        display: none; /* Hide the mobile menu on larger screens */
    }
`
